var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunicationType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 14.6667C9.6121 14.6667 11.9999 12.2789 11.9999 9.33333C11.9999 6.38781 9.6121 4 6.66659 4C3.72107 4 1.33325 6.38781 1.33325 9.33333C1.33325 10.157 1.51997 10.9371 1.85339 11.6335C1.96798 11.8729 2.00822 12.144 1.93962 12.4004L1.72093 13.2178C1.54855 13.862 2.13793 14.4514 2.78215 14.279L3.59951 14.0603C3.85587 13.9917 4.12706 14.0319 4.36642 14.1465C5.06285 14.48 5.84292 14.6667 6.66659 14.6667Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 9.66793C12.0442 9.64945 12.0882 9.63025 12.1317 9.61036C12.3731 9.50009 12.644 9.45886 12.9003 9.52745L13.2177 9.61237C13.8619 9.78474 14.4513 9.19536 14.2789 8.55114L14.194 8.23378C14.1254 7.97742 14.1666 7.70658 14.2769 7.46519C14.5271 6.91737 14.6666 6.30832 14.6666 5.66671C14.6666 3.27347 12.7265 1.33337 10.3333 1.33337C8.53174 1.33337 6.987 2.4327 6.33325 3.99711",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3456 9.33337H4.3516M6.67275 9.33337H6.67875M9.00008 9.33337H9.00608",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationType);
export default __webpack_public_path__ + "static/media/communicationType.eae9950e7e544c3c68fc0d06a53459a0.svg";
export { ForwardRef as ReactComponent };